export enum Permission {
  ADMIN = 'admin',
  CLUSTER = 'cluster',
  FLAVOR = 'flavor',
  CATEGORY_CREATE = 'category.create',
  CATEGORY_UPDATE = 'category.update',
  CATEGORY_DELETE = 'category.delete',
  CATEGORY_VIEW = 'category.view',
  CATEGORY_VISIBLE = 'category.visible',
  CATEGORY_HIDE = 'category.hide',
  CATEGORY_VIEW_NAV = 'category.view.nav',
  CATEGORY_COUPON_HIDE = 'category.coupon.hide',
  CATEGORY_COUPON_VISIBLE = 'category.coupon.visible',
  ARTICLE_CREATE = 'article.create',
  ARTICLE_UPDATE = 'article.update',
  ARTICLE_UPDATE_SIMPLE = 'article.update.simple',
  ARTICLE_DELETE = 'article.delete',
  ARTICLE_VISIBLE = 'article.visible',
  ARTICLE_HIDE = 'article.hide',
  ARTICLE_ACTIVATE = 'article.activate',
  ARTICLE_DEACTIVATE = 'article.deactivate',
  ARTICLE_CONTROL_ACTIVATE = 'article.control.activate',
  ARTICLE_CONTROL_DEACTIVATE = 'article.control.deactivate',
  ARTICLE_PRICE_LOCK = 'article.price.lock',
  ARTICLE_TABLE_COLUMN_SELECTOR = 'article.table.column.selector',
  FOODCARD_IMPORT = 'foodcard.import',
  FOODCARD_EXPORT = 'foodcard.export',
  FOODCARD_SYNC_EXTERNAL = 'foodcard.sync.external',
  ARTICLE_VIEW = 'article.view',
  ARTICLE_VIEW_VISIBLE_ONLY = 'article.view.visible.only',
  OPTION_CREATE = 'option.create',
  OPTION_UPDATE = 'option.update',
  OPTION_DELETE = 'option.delete',
  OPTION_VIEW = 'option.view',
  OPTION_VISIBLE = 'option.visible',
  OPTION_HIDE = 'option.hide',
  OPTION_ARTICLE_CREATE = 'option.article.create',
  OPTION_ARTICLE_UPDATE = 'option.article.update',
  OPTION_ARTICLE_UPDATE_SIMPLE = 'option.article.update.simple',
  OPTION_ARTICLE_DELETE = 'option.article.delete',
  OPTION_ARTICLE_VIEW = 'option.article.view',
  OPTION_ARTICLE_ACTIVATE = 'option.article.activate',
  OPTION_ARTICLE_DEACTIVATE = 'option.article.deactivate',
  OPTION_ARTICLE_VISIBLE = 'option.article.visible',
  OPTION_ARTICLE_HIDE = 'option.article.hide',
  OPTION_ARTICLE_PRICE_LOCK = 'option.article.price.lock',
  OPTION_ARTICLE_VIEW_VISIBLE_ONLY = 'option.article.view.visible.only',
  TABLE_CREATE = 'table.create',
  TABLE_UPDATE = 'table.update',
  TABLE_DELETE = 'table.delete',
  TABLE_VIEW = 'table.view',
  TABLE_EXPORT = 'table.export',
  CONSTRAIN_CREATE = 'constrain.create',
  CONSTRAIN_UPDATE = 'constrain.update',
  CONSTRAIN_DELETE = 'constrain.delete',
  CONSTRAIN_VIEW = 'constrain.view',
  CONSTRAIN_ACTIVATE = 'constrain.activate',
  CONSTRAIN_DEACTIVATE = 'constrain.deactivate',
  PRINTGROUPS_CREATE = 'printgroup.create',
  PRINTGROUPS_UPDATE = 'printgroup.update',
  PRINTGROUPS_DELETE = 'printgroup.delete',
  PRINTGROUPS_VIEW = 'printgroup.view',
  PRINTGROUPS_ACTIVATE = 'printgroup.activate',
  PRINTGROUPS_DEACTIVATE = 'printgroup.deactivate',
  TAG_CREATE = 'tag.create',
  TAG_UPDATE = 'tag.update',
  TAG_DELETE = 'tag.delete',
  TAG_VIEW = 'tag.view',
  PRINTER_CREATE = 'printer.create',
  PRINTER_UPDATE = 'printer.update',
  PRINTER_RESTART = 'printer.restart',
  PRINTER_DELETE = 'printer.delete',
  PRINTER_VIEW = 'printer.view',
  BILLING_CREATE = 'billing.create',
  BILLING_UPDATE = 'billing.update',
  BILLING_DELETE = 'billing.delete',
  BILLING_VIEW = 'billing.view',
  BILLING_FLAVOR = 'billing.flavor',
  LOG_CREATE = 'log.create',
  LOG_UPDATE = 'log.update',
  LOG_DELETE = 'log.delete',
  LOG_VIEW = 'log.view',
  ROLE_CREATE = 'role.create',
  ROLE_UPDATE = 'role.update',
  ROLE_DELETE = 'role.delete',
  ROLE_VIEW = 'role.view',
  ANALYTICS_CREATE = 'analytics.create',
  ANALYTICS_UPDATE = 'analytics.update',
  ANALYTICS_DELETE = 'analytics.delete',
  ANALYTICS_DAILY_EXPORT = 'analytics.daily.export',
  ANALYTICS_FEATURES_EXPORT = 'analytics.features.export',
  ANALYTICS_VIEW = 'analytics.view',
  ANALYTICS_FLAVOR = 'analytics.flavor',
  ANALYTICS_CUSTOMER_GROUP = 'analytics.customerGroup',
  STATISTICS_CREATE = 'statistics.create',
  STATISTICS_UPDATE = 'statistics.update',
  STATISTICS_DELETE = 'statistics.delete',
  STATISTICS_VIEW = 'statistics.view',
  STATISTICS_FLAVOR = 'statistics.flavor',
  STATISTICS_OVERVIEW = 'statistics.overview',
  STATISTICS_OVERVIEW_EXPORT = 'statistics.overview.export',
  STATISTICS_OVERVIEW_EXPORT_PROVISION = 'statistics.overview.export.provision',
  VENUE_CREATE = 'venue.create',
  VENUE_CREATE_SIMPLE = 'venue.create.simple',
  VENUE_UPDATE = 'venue.update',
  VENUE_UPDATE_SIMPLE = 'venue.update.simple',
  VENUE_DELETE = 'venue.delete',
  VENUE_EXPORT = 'venue.export',
  VENUE_ACTIVATE = 'venue.activate',
  VENUE_DEACTIVATE = 'venue.deactivate',
  VENUE_PANIC = 'venue.panic',
  VENUE_VIEW = 'venue.view',
  VENUE_PAYMENT = 'venue.payment',
  VENUE_VERIFY = 'venue.verify',
  VENUE_PUBLISH = 'venue.publish',
  VENUE_FILTER = 'venue.filter',
  VENUE_SYNC_START = 'venue.sync.start',
  VENUE_SYNC_STOP = 'venue.sync.stop',
  VENUE_SEPA_CREATE = 'venue.sepa.create',
  VENUE_SEPA_DELETE = 'venue.sepa.delete',
  VENUE_SEPA_PAY = 'venue.sepa.pay',
  VENUE_PAYPAL_AUTHORIZE = 'venue.paypal.authorize',
  VENUE_PAYPAL_CHECK = 'venue.paypal.check',
  VENUE_MIGRATE_DEV_TO_DEV = 'venue.migrate.devToDev',
  VENUE_MIGRATE_DEV_TO_PROD = 'venue.migrate.devToProd',
  VENUE_MIGRATE_PROD_TO_PROD = 'venue.migrate.prodToProd',
  VENUE_TRANSACTIONS_VIEW = 'venue.transactions.view',
  VENUE_TRANSACTIONS_CREATE = 'venue.transactions.create',
  VENUE_TRANSACTIONS_UPDATE = 'venue.transactions.update',
  VENUE_PARK_COLLECT_VIEW = 'venue.parkcollect.view',
  VENUE_PARK_COLLECT_UPDATE = 'venue.parkcollect.update',
  VENUE_SLUG_GENERATE = 'venue.slug.generate',
  VENUE_CHECKOUTINTEGRATION_VIEW = 'venue.checkoutIntegration.view',
  VENUE_CHECKOUTINTEGRATION_UPDATE = 'venue.checkoutIntegration.update',
  VENUE_VAT_ID_REUSE = 'venue.vat.id.reuse',
  EMPLOYEE_CREATE = 'employee.create',
  EMPLOYEE_UPDATE = 'employee.update',
  EMPLOYEE_DELETE = 'employee.delete',
  EMPLOYEE_VIEW = 'employee.view',
  CUSTOMER_CREATE = 'customer.create',
  CUSTOMER_UPDATE = 'customer.update',
  CUSTOMER_DELETE = 'customer.delete',
  CUSTOMER_VIEW = 'customer.view',
  USER_CREATE = 'user.create',
  USER_CREATE_RESTRICTED = 'user.create.restricted',
  USER_UPDATE = 'user.update',
  USER_UPDATE_RESTRICTED = 'user.update.restricted',
  USER_DELETE = 'user.delete',
  USER_VIEW = 'user.view',
  USER_PASSWORD_RESET = 'user.password.reset',
  USER_PASSWORD_CHANGE = 'user.password.change',
  DASHBOARD_VIEW = 'dashboard.view',
  RECEIPT_CREATE = 'receipt.create',
  RECEIPT_UPDATE = 'receipt.update',
  RECEIPT_DELETE = 'receipt.delete',
  RECEIPT_CUSTOMER_EXPORT = 'receipt.customer.export',
  RECEIPT_MERCHANT_EXPORT = 'receipt.merchant.export',
  RECEIPT_FULL_EXPORT = 'receipt.full.export',
  RECEIPT_VIEW = 'receipt.view',
  PAGE_CREATE = 'page.create',
  PAGE_UPDATE = 'page.update',
  PAGE_DELETE = 'page.delete',
  PAGE_VIEW = 'page.view',
  SALES_CREATE = 'sales.create',
  SALES_UPDATE = 'sales.update',
  SALES_DELETE = 'sales.delete',
  SALES_EXPORT = 'sales.export',
  SALES_FLAVOR = 'sales.flavor',
  SALES_VIEW = 'sales.view',
  SALES_OVERVIEW = 'sales.overview',
  ORDER_CREATE = 'order.create',
  ORDER_UPDATE = 'order.update',
  ORDER_DELETE = 'order.delete',
  ORDER_VIEW = 'order.view',
  ORDER_VEW_FILTER = 'order.view.filter',
  ORDER_VEW_LIST = 'order.view.list',
  ORDER_EXPORT = 'order.export',
  ORDER_PAYMENTMETHOD_EXPORT = 'order.paymentmethod.export',
  ORDER_FILTER_METHOD = 'order.filter.method',
  ORDER_FILTER_SMOOTHR_ONLY = 'order.filter.smoothrOnly',
  ORDER_FILTER_CHECKOUT_INTEGRATION_STATUS = 'order.filter.checkoutIntegrationStatus',
  ORDER_FILTER_STATUS_IN_PREPARATION = 'order.filter.status.in_preparation',
  ORDER_FILTER_STATUS_CREATED = 'order.filter.status.created',
  ORDER_FILTER_STATUS_READY = 'order.filter.status.ready',
  ORDER_FILTER_STATUS_DONE = 'order.filter.status.done',
  ORDER_FILTER_STATUS_VALIDATED = 'order.filter.status.validated',
  ORDER_FILTER_STATUS_FAILED = 'order.filter.status.failed',
  ORDER_FILTER_STATUS_IN_PAYMENT = 'order.filter.status.in_payment',
  ORDER_FILTER_STATUS_CANCELLED_BY_WAITER = 'order.filter.status.cancelled_by_waiter',
  ORDER_FILTER_STATUS_CANCELLED_BY_CUSTOMER = 'order.filter.status.cancelled_by_customer',
  ORDER_FILTER_STATUS_AWAITING_CONFIRMATION = 'order.filter.status.awaiting_confirmation',
  ORDER_FILTER_STATUS_NONE = 'order.filter.status.none',
  ORDER_STATISTICS_EXPORT = 'order.statistics.export',
  ORDER_STATISTICS_EXPORT_NO_CUSTOMERS = 'order.statistics.export.noCustomers',
  ORDER_TEST = 'order.test',
  ORDER_RETRY = 'order.retry',
  ORDER_LOG_VIEW = 'order.log.view',
  INVOICE_VENUE = 'invoice.venue',
  INVOICE_SUMMARY = 'invoice.summary',
  INVOICE_SEND = 'invoice.send',
  INVOICE_VENUE_ARTICLES = 'invoice.venue.articles',
  REFUNDS = 'refunds',
  REFUNDS_SMOOTHR = 'refunds.smoothr',
  REFUNDS_CASH = 'refunds.cash',
  REFUNDS_POS = 'refunds.pos',
  PAYMENT_VIEW = 'payment.view',
  PAYMENT_VIEW_FAILED = 'payment.view.failed',
  PAYMENT_DATEV_EXPORT = 'payment.datev.export',
  PAYMENT_LOG_VIEW = 'payment.log.view',
  MAINTENANCE_CREATE = 'maintenance.create',
  MAINTENANCE_UPDATE = 'maintenance.update',
  PROMO_CODE_CREATE = 'promoCode.create',
  PROMO_CODE_CREATE_OWN = 'promoCode.create.own',
  PROMO_CODE_VIEW = 'promoCode.view',
  PROMO_CODE_VIEW_GLOBAL = 'promoCode.view.global',
  PROMO_CODE_VIEW_SIMPLE = 'promoCode.view.simple',
  PROMO_CODE_UPDATE = 'promoCode.update',
  PROMO_CODE_ACTIVATE = 'promoCode.activate',
  PROMO_CODE_DEACTIVATE = 'promoCode.deactivate',
  PROMO_CODE_ENABLE = 'promoCode.enable',
  PROMO_CODE_DISABLE = 'promoCode.disable',
  PROMO_CODE_DELETE = 'promoCode.delete',
  PROMO_CODE_EXPORT = 'promoCode.export',
  PROMO_CODE_EXPORT_SUMMARY = 'promoCode.export.summary',
  PROMO_CODE_EXPORT_COUNT = 'promoCode.export.count',
  PROMO_CODE_EXPORT_OVERVIEW = 'promoCode.export.overview',
  PROMO_CODE_FLAVOR = 'promoCode.flavor',
  PROMO_CODE_UPDATE_TIMEFRAME = 'promoCode.update.timeframe',
  COUPON_CREATE = 'coupon.create',
  COUPON_CREATE_OWN = 'coupon.create.own',
  COUPON_VIEW = 'coupon.view',
  COUPON_VIEW_GLOBAL = 'coupon.view.global',
  COUPON_VIEW_SIMPLE = 'coupon.view.simple',
  COUPON_UPDATE = 'coupon.update',
  COUPON_ACTIVATE = 'coupon.activate',
  COUPON_DEACTIVATE = 'coupon.deactivate',
  COUPON_ENABLE = 'coupon.enable',
  COUPON_DISABLE = 'coupon.disable',
  COUPON_DELETE = 'coupon.delete',
  COUPON_EXPORT = 'coupon.export',
  COUPON_EXPORT_SUMMARY = 'coupon.export.summary',
  COUPON_EXPORT_COUNT = 'coupon.export.count',
  COUPON_EXPORT_OVERVIEW = 'coupon.export.overview',
  COUPON_FLAVOR = 'coupon.flavor',
  PROVISION_VIEW = 'provision.view',
  PROVISION_CLAIM = 'provision.claim',
  PROVISION_CLAIM_RESET = 'provision.claim.reset',
  PROVISION_LOGS = 'provision.logs',
  LABEL_CREATE = 'label.create',
  LABEL_UPDATE = 'label.update',
  LABEL_DELETE = 'label.delete',
  LABEL_VIEW = 'label.view',
  INFORMATION_CREATE = 'information.create',
  INFORMATION_UPDATE = 'information.update',
  INFORMATION_DELETE = 'information.delete',
  INFORMATION_VIEW = 'information.view',
  REPORTING_VIEW = 'reporting.view',
  REPORTING_FLAVOR = 'reporting.flavor',
  DELIVERY_PROVIDER_ACTIVATION = 'deliveryProvider.activation',
  DELIVERY_PROVIDER_ENABLING = 'deliveryProvider.enabling',
  SCREENSAVER_CREATE = 'screensaver.create',
  SCREENSAVER_UPDATE = 'screensaver.update',
  SCREENSAVER_VIEW = 'screensaver.view',
  SCREENSAVER_DELETE = 'screensaver.delete',
  MEMBERSHIP_LEVELS_CREATE = 'membershiplevels.create',
  MEMBERSHIP_LEVELS_UPDATE = 'membershiplevels.update',
  MEMBERSHIP_LEVELS_DELETE = 'membershiplevels.delete',
  MEMBERSHIP_LEVELS_VIEW = 'membershiplevels.view',
  EPOS_JOB_CREATE = 'eposjob.create',
  EPOS_JOB_UPDATE = 'eposjob.update',
  EPOS_JOB_DELETE = 'eposjob.delete',
  EPOS_JOB_VIEW = 'eposjob.view',
  SANIFAIR_VIEW = 'sanifair.view',
  JOB_CREATE = 'job.create',
  JOB_UPDATE = 'job.update',
  JOB_DELETE = 'job.delete',
  JOB_VIEW = 'job.view',
  TIPS_VIEW = 'tips.view',
  LIGHTSPEED_AUTHORIZE = 'lightspeed_authorize',
  WOLT_FOODCARD_SYNC = 'wolt.foodcard.sync',
  WOLT_VENUE_STATUS = 'wolt.venue.status',
  WOLT_VENUE_OPENING_HOURS = 'wolt.venue.openingHours',
  WOLT_SYNC_JOB_VIEW = 'wolt.syncJob.view',
  WOLT_CONNECT = 'wolt.connect',
  WOLT_DISPATCH = 'wolt.dispatch',
  WOLT_OFFSETS = 'wolt.offsets',
  RECOMMENDATIONS_CREATE = 'recommendations.create',
  RECOMMENDATIONS_UPDATE = 'recommendations.update',
  RECOMMENDATIONS_DELETE = 'recommendations.delete',
  RECOMMENDATIONS_VIEW = 'recommendations.view',
  UBER_EATS_FOODCARD_SYNC = 'uber.eats.foodcard.sync',
  UBER_EATS_VENUE_STATUS = 'uber.eats.venue.status',
  UBER_EATS_VENUE_OPENING_HOURS = 'uber.eats.venue.openingHours',
  UBER_EATS_SYNC_JOB_VIEW = 'uber.eats.syncJob.view',
  UBER_EATS_CONNECT = 'uber.eats.connect',
  UBER_EATS_DISPATCH = 'uber.eats.dispatch',
  UBER_EATS_OFFSETS = 'uber.eats.offsets',
  JET_FOODCARD_SYNC = 'jet.foodcard.sync',
  JET_VENUE_STATUS = 'jet.venue.status',
  JET_VENUE_OPENING_HOURS = 'jet.venue.openingHours',
  JET_SYNC_JOB_VIEW = 'jet.syncJob.view',
  JET_DISPATCH = 'jet.dispatch',
  JET_OFFSETS = 'jet.offsets',
  JET_SETTINGS = 'jet.settings',
  INVENTORY_CREATE = 'inventory.create',
  INVENTORY_VIEW = 'inventory.view',
  INVENTORY_UPDATE = 'inventory.update',
  INVENTORY_DELETE = 'inventory.delete',
  DND_COMPANY_CREATE = 'dnd.company.create',
  DND_COMPANY_VIEW = 'dnd.company.view',
  DND_COMPANY_UPDATE = 'dnd.company.update',
  DND_COMPANY_DELETE = 'dnd.company.delete',
  UI_CARD_CREATE = 'ui.card.create',
  UI_CARD_VIEW = 'ui.card.view',
  UI_CARD_UPDATE = 'ui.card.update',
  UI_CARD_DELETE = 'ui.card.delete',
  UI_SLIDER_CREATE = 'ui.slider.create',
  UI_SLIDER_VIEW = 'ui.slider.view',
  UI_SLIDER_UPDATE = 'ui.slider.update',
  UI_SLIDER_DELETE = 'ui.slider.delete',
  UI_BANNER_CREATE = 'ui.banner.create',
  UI_BANNER_VIEW = 'ui.banner.view',
  UI_BANNER_UPDATE = 'ui.banner.update',
  UI_BANNER_DELETE = 'ui.banner.delete',
  MFA_ENABLE = 'mfa.enable',
  MFA_DISABLE = 'mfa.disable',
  CAMPAIGN_CREATE = 'campaign.create',
  CAMPAIGN_VIEW = 'campaign.view',
  CAMPAIGN_UPDATE = 'campaign.update',
  CAMPAIGN_DELETE = 'campaign.delete',
  ORDER_POOL_VIEW = 'order.pool.view',
  ORDER_POOL_UPDATE = 'order.pool.update',
  HEIDE_PARK_SEASON_PASS_UPLOAD = 'heidePark.seasonPass.upload',
  UBER_DIRECT_TOGGLE = 'uber.direct.toggle',
  ULTRA_DISPO_TOGGLE = 'ultraDispo.toggle',
  WOLT_DRIVE_TOGGLE = 'wolt.drive.toggle',
  SMOOTHR_DISPATCH_TOGGLE = 'smoothr.dispatch.toggle',
  SYNC_MASTER_SLAVES = 'sync.master.slaves',
  SYNC_DEV_TO_DEV = 'sync.dev.to.dev',
  SYNC_DEV_TO_PROD = 'sync.dev.to.prod',
  SYNC_PROD_TO_DEV = 'sync.prod.to.dev',
  SYNC_PROD_TO_PROD = 'sync.prod.to.prod',
  SYNC_SLAVE_SLAVES = 'sync.slave.slaves',
  SYNC_VENUE_COPY_FULL = 'sync.venue.copy.full',
  SYNC_VENUE_COPY_ONLY = 'sync.venue.copy.only',
  SYNC_JOB_VIEW = 'sync.job.view',
  SYNC_JOB_STOP = 'sync.job.stop',
  TABLE_SANIFAIR_COUNTER_VIEW = 'table.sanifairCounter.view',
  AUDIT_LOGS_VIEW = 'audit.logs.view',
  AUDIT_LOGS_VIEW_ARTICLE = 'audit.logs.view.article',
  AUDIT_LOGS_VIEW_ARTICLE_CATEGORY = 'audit.logs.view.article.category',
  AUDIT_LOGS_VIEW_OPTION_ARTICLE = 'audit.logs.view.option.article',
  OAUTH_ENROLLMENT_LIST = 'oauth.enrollment.list',
  OAUTH_ENROLLMENT_ACCEPT = 'oauth.enrollment.accept',
  OAUTH_ENROLLMENT_REJECT = 'oauth.enrollment.reject',
  DELIVEROO_FOODCARD_SYNC = 'deliveroo.foodcard.sync',
  DELIVEROO_VENUE_STATUS = 'deliveroo.venue.status',
  DELIVEROO_VENUE_OPENING_HOURS = 'deliveroo.venue.openingHours',
  DELIVEROO_SYNC_JOB_VIEW = 'deliveroo.syncJob.view',
  UPSELL_CREATE = 'upsell.create',
  UPSELL_VIEW = 'upsell.view',
  UPSELL_UPDATE = 'upsell.update',
  UPSELL_DELETE = 'upsell.delete',
  DEPOSIT_RULE_CREATE = 'deposit.rule.create',
  DEPOSIT_RULE_VIEW = 'deposit.rule.view',
  DEPOSIT_RULE_UPDATE = 'deposit.rule.update',
  DEPOSIT_RULE_DELETE = 'deposit.rule.delete',
  WALLET_EXPORT = 'wallet.export',
}
